import request from '@/utils/request'

const addressURl = {
    deadLinksBrandList: '/die-links/brand-items',
    deadLinksBrandUpdate: '/die-links/brand-update',
    deadLinksList: '/die-links/items',
    deadLinksCreate: '/die-links/create',
    deadLinksUpdate: '/die-links/update',
    deadLinksDetail: '/die-links/delete',
}

// 死链品牌列表
export function deadLinksBrandList(data) {
    return request({
        url: addressURl.deadLinksBrandList,
        method: 'post',
        data
    })
}

// 死链品牌更新
export function deadLinksBrandUpdate(data) {
    return request({
        url: addressURl.deadLinksBrandUpdate,
        method: 'post',
        data
    })
}

// 死链列表
export function deadLinksList(data) {
    return request({
        url: addressURl.deadLinksList,
        method: 'post',
        data
    })
}

// 死链添加
export function deadLinksCreate(data) {
    return request({
        url: addressURl.deadLinksCreate,
        method: 'post',
        data
    })
}
// 死链编辑
export function deadLinksUpdate(data) {
    return request({
        url: addressURl.deadLinksUpdate,
        method: 'post',
        data
    })
}
// 死链删除
export function deadLinksDetail(data) {
    return request({
        url: addressURl.deadLinksDetail,
        method: 'post',
        data
    })
}

export default {
    deadLinksBrandList,
    deadLinksBrandUpdate,
    deadLinksList,
    deadLinksCreate,
    deadLinksUpdate,
    deadLinksDetail,
}
